import { useQuery } from '@tanstack/react-query'
import { societyQueries } from '../api/societies'
import { useSelectedSocietyId } from './useSelectedSocietyContext'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useCurrentSociety = () => {
  const { selectedSocietyId } = useSelectedSocietyId()
  const { data: society, ...rest } = useQuery(
    societyQueries.getSociety(selectedSocietyId)
  )
  return { society, ...rest }
}
